import React, { useState, useEffect, useContext, useCallback } from 'react';
import { connect } from 'react-redux';
import { embedVideo } from '../../../../actionCreators/common';
import { confirmCOD, getOrders, clearConfirmCODState } from '../../../../actionCreators/myAccount';
import { getOrder } from '../../../../actionCreators/order';
import sessionStorageHelper from '../../../../utils/sessionStorageHelper';
import Items from './Items';
import OrderHeader from '../../../../CommonComponents/OrderStatus/OrderHeader';
import PayNow from '../../../../CommonComponents/OrderStatus/PayNow';
import Footer from './Footer';
import { OrderContext } from './OrderListing';
import { OrderDetailContext } from './OrderDetail';
import EmbedVideo from '../../../../CommonComponents/EmbedVideo/Loadable';
import LKModal from '../../Modal/Modal';
import ConfirmCOD from '../../../../CommonComponents/OrderStatus/ConfirmCOD';
import InfoModalComponent from '../../Common/InfoModalComponent';
import PostDispatchCancellation from '../../../../CommonComponents/OrderStatus/PostDispatchCancellation';
import PostDispatchCancellationMessage from '../../../../CommonComponents/OrderStatus/PostDispatchCancellationMessage';
import './Order.scss';
import BookAppointmentStatus from './BookAppointmentStatus';
import BookAppointment from './BookAppointment';
import AppointmentBookedStatus from './AppointmentBookedStatus';

function closeVideo(updateEmbedVideo) {
  updateEmbedVideo({ embedVideo: null });
}

function updateOrder(id, getOrders, listing, getOrder) {
  const pageNumber = sessionStorageHelper.getItem('orderActivePage') || 0;
  const pager = pageNumber <= 1 ? 0 : pageNumber - 1;
  getOrders(pager, 10);
  if (!listing) getOrder({ orderId: id, dontInitSession: true, isMyAcct: true });
}

function Order(props) {
  const {
    history,
    updateEmbedVideo,
    returnEligibiliyDetails,
    currencyMark,
    embedVideo,
    order,
    listing,
    email,
    order: {
      items,
      id,
      insuranceProviderId = '',
      payments: { paymentList },
      status: { state, trackingStatus },
    },
    getOrderDetails,
    refundExchangeInfoFunc,
    codConfirm,
    confirmCOD,
    getOrders,
    getOrder,
    clearConfirmCODState,
    dataLocale,
    studioFlowReducer,
    redisCommonData,
    orderDetails,
    localeInfo,
  } = props;
  const [payNow, setPayNow] = useState(null);
  const [pendingStatus, setPendingStatus] = useState('');
  const [codConfirmErr, showModal] = useState(false);
  const [isModalOpen, setAppointmnetModal] = useState(false);
  const [isAppointmentBooked, setAppointmentStatus] = useState(false);
  const [loader, setloading] = useState(false);
  const { orderStatusRedis, userInfo } =
    useContext(listing ? OrderContext : OrderDetailContext) || {};
  const modalCloseFunc = useCallback(closeVideo.bind(null, updateEmbedVideo), []);
  const [isItemsInTransit, setItemsInTransit] = useState(false);
  const [cancellationPopup, showPopup] = useState(false);
  const [isSuccessModal, openSuccessModal] = useState(false);
  const freshBotConfig =
    redisCommonData?.FRESHBOT_CONFIG && JSON.parse(redisCommonData.FRESHBOT_CONFIG);
  const sprinklrBotConfig =
    redisCommonData?.SPRINKLR_BOT_CONFIG && JSON.parse(redisCommonData.SPRINKLR_BOT_CONFIG);
  const needHelpListingEnabled =
    sprinklrBotConfig?.desktop_enabled === 'ON'
      ? sprinklrBotConfig?.needHelpListingEnabledDesktop
      : freshBotConfig?.needHelpListingEnabled;
  const togglePopupState = useCallback(() => {
    showPopup(!cancellationPopup);
  }, [cancellationPopup]);
  const codConfirmation = useCallback(() => {
    if (loader) return;
    confirmCOD(id);
  }, []);
  const closeCodErrModal = useCallback(() => showModal(false), []);
  const updateOrderFun = useCallback(
    updateOrder.bind(null, id, getOrders, listing, getOrder, clearConfirmCODState),
    []
  );
  useEffect(() => {
    const cod = paymentList.some(payment => payment.method === 'cod') && state === 'NEW';
    const pendingPayment = trackingStatus === 'PAYMENT_NOT_INITIATED';
    const pendingOnInsurer = insuranceProviderId && state === 'NEW';
    let payNowFlag = '';
    if (cod) {
      payNowFlag = 'cod';
    } else if (pendingPayment) {
      payNowFlag = 'pendingPayment';
    } else if (pendingOnInsurer) {
      payNowFlag = 'pendingOnInsurer';
    }
    if (orderStatusRedis && payNowFlag) {
      const { payNow: payNowConfig } = JSON.parse(orderStatusRedis);
      setPayNow(payNowConfig[payNowFlag]);
    } else {
      setPayNow(null);
    }
    setPendingStatus(payNowFlag);
    if (!listing) {
      EmbedVideo.preload();
      window.onpopstate = function () {
        updateEmbedVideo({ embedVideo: null });
      };
      setItemsInTransit(items.some(item => item.itemTracking?.status === 'IN_TRANSIT'));
    }
  }, [order]);

  useEffect(() => {
    if (isAppointmentBooked && studioFlowReducer?.bookTime) {
      getOrder({ orderId: id, dontInitSession: true, isMyAcct: true });
    }
  }, [studioFlowReducer]);
  useEffect(() => {
    if (isAppointmentBooked && orderDetails) {
      openSuccessModal(!isSuccessModal);
    }
  }, [orderDetails]);
  useEffect(() => {
    if (codConfirm && codConfirm[id]) {
      if (codConfirm[id].loading) {
        setloading(true);
      } else {
        if (codConfirm[id].result) {
          updateOrderFun();
        } else if (codConfirm[id].error) {
          showModal(true);
        }
        clearConfirmCODState(id);
        setloading(false);
      }
    }
  }, [codConfirm]);
  return (
    <div className="clearfix margin-b40" data-testid="orderBox">
      <div className="order-box bora-8">
        <OrderHeader
          currencyMark={currencyMark}
          dataLocale={dataLocale}
          order={order}
          redisCommonData={redisCommonData}
          view="desktop"
        />
        {pendingStatus === 'cod' && (
          <ConfirmCOD
            codConfirmation={codConfirmation}
            dataLocale={dataLocale}
            listing={listing}
            loading={loader}
            view="desktop"
          />
        )}
        {Boolean(pendingStatus === 'pendingPayment' && payNow) && (
          <PayNow
            dataLocale={dataLocale}
            email={email}
            listing={listing}
            localeInfo={localeInfo}
            order={order}
            payNow={payNow}
            view="desktop"
          />
        )}
        {order.studioFlow && redisCommonData?.STUDIO_FLOW_WEB && (
          <BookAppointmentStatus
            dataLocale={dataLocale}
            isModalOpen={isModalOpen}
            order={order}
            setAppointmnetModal={setAppointmnetModal}
          />
        )}
        {codConfirmErr && (
          <InfoModalComponent
            callback={closeCodErrModal}
            headerTitle={dataLocale.REQUEST_NOT_PROCESSED}
            msgContent={dataLocale.TECHNICAL_ERROR_TRY_AGAIN}
            msgType="danger"
          />
        )}
        <Items
          dataLocale={dataLocale}
          history={history}
          listing={listing}
          orderData={order}
          pendingOrderStatus={pendingStatus}
          returnEligibilityItems={(returnEligibiliyDetails && returnEligibiliyDetails.items) || []}
        />
      </div>
      {isItemsInTransit && (
        <PostDispatchCancellationMessage
          clickHandler={togglePopupState}
          dataLocale={dataLocale}
          userInfo={userInfo}
          view="desktop"
        />
      )}
      {!order?.isInsuranceFlow && (
        <Footer
          dataLocale={dataLocale}
          freshBotEnabled={freshBotConfig?.enabled}
          // needHelpListingEnabled={freshBotConfig?.needHelpListingEnabled}
          getOrderDetails={getOrderDetails}
          history={history}
          listing={listing}
          needHelpListingEnabled={needHelpListingEnabled}
          order={order}
          refundExchangeInfoFunc={refundExchangeInfoFunc}
          sprinklrBotEnabled={sprinklrBotConfig?.desktop_enabled}
          userInfo={userInfo}
        />
      )}
      {isModalOpen && redisCommonData?.STUDIO_FLOW_WEB && order?.studioFlow && (
        <LKModal
          backdrop="static"
          dialogClassName="timeline-video"
          hideHandler={setAppointmnetModal}
          sgBookAppointment={!isSuccessModal}
          showModal={isModalOpen}
          size="large"
        >
          {!isSuccessModal ? (
            <BookAppointment
              dataLocale={dataLocale}
              hideHandler={setAppointmnetModal}
              isModalOpen={isModalOpen}
              order={order}
              orderId={id}
              redisCommonData={redisCommonData}
              setAppointmentStatus={setAppointmentStatus}
              // storeCode="LKST530"
              storeCode={order?.studioStoreDetails?.code}
            />
          ) : (
            <AppointmentBookedStatus
              dataLocale={dataLocale}
              order={orderDetails?.result?.orders[0]}
              setAppointmnetModal={setAppointmnetModal}
            />
          )}
        </LKModal>
      )}
      {!listing && embedVideo && (
        <LKModal
          backdrop="static"
          dialogClassName="timeline-video"
          hideHandler={modalCloseFunc}
          showModal={Boolean(embedVideo)}
          size="large"
        >
          <div
            className="dialog-close pos-abs fs18 bg-color-white bora-50cent justify-content-center display-flex align-items-center"
            data-testid="closeModalBtn"
            onClick={modalCloseFunc}
          >
            <i aria-hidden="true" className="fa fa-times"></i>
          </div>
          <EmbedVideo hideCloseButton videoId={embedVideo} />
        </LKModal>
      )}
      {cancellationPopup && (
        <LKModal
          backdrop="static"
          dialogClassName="order-cancellation-modal lkModal"
          showModal={cancellationPopup}
          size="small"
        >
          <PostDispatchCancellation
            clickHandler={togglePopupState}
            dataLocale={dataLocale}
            userInfo={userInfo}
            view="desktop"
          />
        </LKModal>
      )}
    </div>
  );
}

const mapStateToProps = state => ({
  embedVideo: state.common.embedVideo,
  orderDetails: state.order?.orderDetails,
  studioFlowReducer: state.studioFlowReducer,
  codConfirm: state.myAccount?.codConfirm,
  dataLocale: state.locale,
  redisCommonData: state.common.redisCommonData,
  currencyMark: state.common.currencyMark,
  localeInfo: state.common.localeInfo,
});

const mapDispatchToProps = dispatch => {
  return {
    updateEmbedVideo: data => dispatch(embedVideo(data)),
    confirmCOD: orderId => dispatch(confirmCOD(orderId)),
    getOrders: (pageName, size) => dispatch(getOrders(pageName, size)),
    getOrder: data => dispatch(getOrder(data)),
    clearConfirmCODState: orderId => dispatch(clearConfirmCODState(orderId)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Order);
